<script>
// import "./plugins/select2.css"
// import "./plugins/select2.min.js"
import "./dist/css/select2.css"
import "./dist/js/select2.min.js"
import BOGen from '../../helper/BOGen';

var $ = window.$;

export default {
  name: "Select2",
  props: {
    url: String,
    filter: String, 
    options:[Object, Array],
    additional: [Object, Array],
    value:[String, Number, Array],
    object:Array,
    selectClass:String,
    multiple:Boolean,
    isDestroy:{default:false,type:Boolean},
    firstHit: {default:true, type:Boolean}
  },
  data(){
    return {
      mrData:[],
    }
  },
  computed:{
    page(){ return this.$root.page },
    data(){
      var data = this.options || this.mrData || []
      if(this.filter) return data.filter((x)=>{ try{return eval(this.filter);}catch{} })
      if(this.additional){
        if(Array.isArray(data)){
          data = data.concat(this.additional)
        }else{
          this.additional.forEach((v,k)=>{
            data[k] = v
          })
        }
      }
      return data
    },
  },
  mounted() {
    $(this.$el)
      .select2({
        dropdownCssClass: this.selectClass,
        containerCssClass: this.selectClass,
        allowClear: false,
        escapeMarkup: function(m) { return m; }
      })
      .val(this.value)
      .trigger('change')
      // emit event on change.
      .on('change', (resp) => {
        resp.val = this.multiple ? $(this.$el).val() : resp.currentTarget.value;

        this.$emit('change', resp)
        this.$emit('input', (this.multiple ? $(this.$el).val() : resp.currentTarget.value));
        if($(this.$el).closest("form").length) $(this.$el).valid();
      });
    if(this.url) this.updateMrData()
  },
  methods:{
    optLabel(k,v){
      if(!this.object) return v
      if(this.object[0]=='same') return v
      if(this.object[1]){
        if(typeof this.object[1] == "function"){
          return this.object[1](v);
        }
        var obj = this.object[1].split("+");
        if(obj[1]) return v[obj[0]]+" "+v[obj[1]];
      }
      return v[this.object[1]]
    },
    optValue(k,v){
      if(!this.object) return k
      if(this.object[0]=='same') return v
      return v[this.object[0]]
    },
    updateMrData(){
      BOGen.apirest(this.url, {}, (e,resp)=>{
        if(e) return console.error(e)
        this.mrData = resp.data
        this.reinit()
      })
    },
    reinit(){
      setTimeout(()=>{
        if(this.firstHit){
          if(Array.isArray(this.data)) if(!this.data.filter((v,k)=>{ return this.optValue(k,v) == this.value }).length){
            this.$emit("input", "")
          }
        }
        $(this.$el).val(this.value).select2({
          escapeMarkup(m) { return m; }
        })
      },10)
    }
  },
  watch: {
    value(value) {
      if(this.data.length){
        this.$emit("selectedObject", this.data.filter((x,k)=>{ return this.optValue(k,x) == this.value })[0] || {})
      }
      $(this.$el).val(value).select2({ escapeMarkup(m) { return m; } });
    },
    options(){
      this.reinit()
    },
    url(){
      // this.$emit("input", "")
      this.updateMrData()
    },
    filter(){
      // this.$emit("input", "")
      this.reinit()
    }
  },
  destroyed() {
    $(this.$el).off().select2('destroy');
  }
}
</script>

<template>
  <select :multiple="multiple">
    <slot></slot>
    <option v-for="(v,k) in data" :value="optValue(k,v)" :key="k">
      {{optLabel(k,v)}}      
    </option>
  </select>
</template>